"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var UgcCarousel_1 = require("../components/UGC/UgcCarousel");
var targetNodes = document.querySelectorAll('.ugc-carousel-section');
if (targetNodes) {
    targetNodes.forEach(function (item) {
        (0, preact_1.render)((0, preact_1.h)(UgcCarousel_1.default, { isNewUGC: window.isNewUGC }), item);
    });
}
